module.exports = __webpack_public_path__ + "assets/img/reserve-type-icon1.3be05d50.png";